import React, { useState, useEffect, useRef } from "react";
import Students from "./Mapofstudentsdatabase/Mapofstudentsdatabase";
import axios from "axios";
import logo2 from "./logo2.png";
import RadioButton from "./MapOfAvailableClasses/AvailableClasses";


import Classes from "./Mapofclassroom/Mapofclassroom";
// eslint-disable-next-line
import {
  Link, Route, Routes, useParams, useNavigate, useLocation, redirect,
} from "react-router-dom";
import { auth, firebase } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot, orderBy, limit, collection, addDoc, query, where, getDocs,
  deleteDoc, doc, setDoc, getDoc, updateDoc, arrayUnion, FieldValue, getCountFromServer,
} from "@firebase/firestore";
import {
  admin, getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword,
  sendEmailVerification, onAuthStateChanged, deleteUser,
} from "@firebase/auth";
import NavBar from "./Navbar";
import "./App.css";
import { use } from "react";
import Particles from "./Particles.js";
import Particlestest from "./BirthdayParticles.js";

function App(props) {


  const { only2studentid, studentid, language, role, id } = useParams();


  const [id2, setId2] = useState();
  // Add state variables for the other passed values
  const [school, setSchool] = useState();
  const [town, setTown] = useState();
  const [state, setState] = useState();
  const [role2, setRole2] = useState();
  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();

  const [donotshow, setDonotshow] = useState();
  const [temparray, setTemparray] = useState();
  const [selectedclass, setSelectedclass] = useState();

  const [activeid, setActiveid = useState] = useState();
  const [activestudentlist, setActivestudentlist] = useState();

  const [activestudentlist2, setActivestudentlist2] = useState([]);

  const [activename, setActivename] = useState();
  const [activeperiod, setActiveperiod] = useState("");
  const [gclassroomid5, setGclassroomid5] = useState("");

  const [gclassroomid, setGclassroomid] = useState("");
  const [gclassroomname, setGclassroomname] = useState("");

  const [currentclass, setCurrentclass] = useState();

  const [currentstudent, setCurrentstudent] = useState();
  const [studentidd, setStudentidd] = useState();

  const [parentlanguagecode, setParentlanguagecode] = useState();

  const [isMobile, setIsMobile] = useState(false);

  const [accesstoken, setAccesstoken] = useState();
  const [refreshtoken, setRefreshtoken] = useState();
  const [expiryDate, setExpiryDate] = useState();

  const [personaldata, setPersonaldata] = useState();
  const [allclassdata, setAllclassdata] = useState();
  const [currentpass, setCurrentpass] = useState();

  const [passexists, setPassexists] = useState("");
  const [whenpassbegan, setWhenpassbegan] = useState(0);


  const [secondssince, setSecondssince] = useState(0);
  const [stringwhichshowsminutesandseconds, setStringwhichshowsminutesandseconds] = useState("0:00");



  const [makeapass, setMakeapass] = useState(false);
  const [destination, setDestination] = useState("");
  const [custom, setCustom] = useState(false);

  const [passismade, setPassismade] = useState(false);

  const [leavetimeGlobal, setLeavetimeGlobal] = useState();
  const [realtimeleave, setRealtimeleave] = useState();
  const [realtimereturn, setRealtimereturn] = useState();
  const [currentdate, setCurrentdate] = useState("");
  const [rightnow, setRightnow] = useState();
  const [leftclass, setLeftclass] = useState();
  const [scanned, setScanned] = useState(false);
  const [text, setText] = useState("Not yet scanned");
  const [hasPermission, setHasPermission] = useState(null);
  const [completed, setCompleted] = useState();
  const [expectedreturn, setExpectedreturn] = useState();
  const [showspinner, setShowspinner] = useState();
  const [getschoolid, setGetschoolid] = useState();

  const [bringinmenu2, setBringinmenu2] = useState(false);
  const [newwidth, setNewwidth] = useState();

  const [teacherid, setTeacherid] = useState();
  const [isFocused, setIsFocused] = useState();
  const [isfocused3, setIsfocused3] = useState();

  const [bathroomtime, setBathroomtime] = useState();
  const [drinktime, setDrinktime] = useState();
  const [othertime, setOthertime] = useState();


  const [summary, setSummary] = useState(false);



  const [linkedclass, setLinkedclass] = useState();
  const [language2, setLanguage2] = useState();
  const [parentlanguage2, setParentlanguage2] = useState();
  const [languagecode2, setLanguagecode2] = useState();
  const [parentlanguagecode2, setParentlanguagecode2] = useState();
  const [coursename, setCoursename] = useState();
  const [currentlocation, setCurrentlocation] = useState();
  const [notificationid, setNotificationid] = useState("12345");
  const [gotteachernotificationid, setGotteachernotificationid] = useState();
  const [teacheridforreturn, setTeacheridforreturn] = useState("");
  const [teacher, setTeacher] = useState();
  const [locationdestination, setLocationdestination] = useState();
  const [pnumber, setPnumber] = useState();
  const [iamenrolled2, setIamenrolled2] = useState(true);
  const [passid, setPassid] = useState("");
  const [allottedtime, setAllottedtime] = useState();

  const [timerIntervalRef, setTimerIntervalRef] = useState(null);


  const [numberofpasses, setNumberofpasses] = useState();
  const [numberofpasses2, setNumberofpasses2] = useState();

  const [overunderr, setOverunderr] = useState();
  const [overunderr2, setOverunderr2] = useState();

  const [totalallowed, setTotalallowed] = useState();

  const [timeofreturn, setTimeofreturn] = useState(0);
  const [expectedtimeofreturn, setExpectedtimeofreturn] = useState(0);

  const [showgrades, setShowgrades] = useState(false);


  const [gccompare2, setGccompare2] = useState();             // gccompare
  const [gcdatasent2, setGcdatasent2] = useState();           // gcdatasent
  const [gctimesent2, setGctimesent2] = useState();           // gctimesent
  const [gc1title2, setGc1title2] = useState();               // gc1title
  const [gc1compare2, setGc1compare2] = useState();           // gc1compare
  const [gc1datasent2, setGc1datasent2] = useState();         // gc1datasent
  const [gc1timesent2, setGc1timesent2] = useState();         // gc1timesent
  const [sid2, setSid2] = useState(id);                         // sid
  const [only2studentid2, setOnly2studentid2] = useState(id);   // only2studentid
  const [studentid2, setStudentid2] = useState(id);             // studentid
  const [selectedclass2, setSelectedclass2] = useState();     // selectedclass
  const [selectedclass12, setSelectedclass12] = useState();   // selectedclass1
  const [showpersonal2, setShowpersonal2] = useState(true);       // showpersonal
  const [gradereceived2, setGradeReceived2] = useState();     // gradereceived
  const [nameinobject2, setNameinobject2] = useState();       // nameinobject
  const [googleclassroomid2, setGoogleclassroomid2] = useState(); // googleclassroomid
  const [averageofgradeswithzeros2, setAverageofgradeswithzeros2] = useState(); // averageofgradeswithzeros
  const [averageofgrades2, setAverageofgrades2] = useState(); // averageofgrades
  const [lowscore2, setLowscore2] = useState();               // lowscore
  const [highscore2, setHighscore2] = useState();

  const [showbirthday, setShowbirthday] = useState(false);
  const [assignmentisgraded, setAssignmentisgraded] = useState(false);

  const [nextbirthday, setNextbirthday] = useState("01/01/2027");
  const [nextBirthdayFirstName, setNextBirthdayFirstName] = useState("");
  const [nextBirthdayLastName, setNextBirthdayLastName] = useState("");

  const [photoUrl, setPhotoUrl] = useState("");

  const [studentemail, setStudentemail] = useState();

  const [parentemail, setParentemail] = useState();

  // Store pre-calculated birthday info for all classes
  const [classessBirthdayInfo, setClassesBirthdayInfo] = useState({});
  const [localclosewebpass, setLocalclosewebpass] = useState(false);

  const [showpassperformance, setShowpassperformance] = useState(false);
  const [showBehaviorDetail, setShowBehaviorDetail] = useState(false);
  const [showPassDetail, setShowPassDetail] = useState(false);
  const [lockedModalHeight, setLockedModalHeight] = useState(null);
  const [behaviorHover, setBehaviorHover] = useState(false);
  const [passHover, setPassHover] = useState(false);
  const modalRef = useRef(null);
  const showGradesButtonLogPrefix = "[Show Grades In Context]";

  // Check if assignment is graded for the student
  useEffect(() => {
    if (gc1datasent2 && Array.isArray(gc1datasent2) && id) {
      console.log("Checking assignment grading for student id:", id);
      console.log("gc1datasent2:", gc1datasent2);

      // Find the student object with id matching the URL parameter
      const studentGrade = gc1datasent2.find(item => item.id === id);

      if (studentGrade) {
        console.log("Found matching student:", studentGrade);
        console.log("Student grade:", studentGrade.grade);

        // Check if grade is greater than 0
        if (typeof studentGrade.grade === 'number' && studentGrade.grade > 0) {
          setAssignmentisgraded(true);
          console.log("Assignment is graded: true");
        } else {
          setAssignmentisgraded(false);
          console.log("Assignment is graded: false");
        }
      } else {
        console.log("No matching student found in gc1datasent2");
        setAssignmentisgraded(false);
      }
    }
  }, [gc1datasent2, id]);



  async function begintimer(whenpassbegan) {
    const startTime = whenpassbegan;

    // Clear any existing interval first
    if (timerIntervalRef) {
      clearInterval(timerIntervalRef);
    }

    // Create new interval
    const newInterval = setInterval(() => {
      // Only update if we still have an active pass
      if (passismade) {
        const elapsed = Math.floor((Date.now() - startTime) / 1000);
        setSecondssince(elapsed);
      } else {
        // Clear the interval if pass is no longer active
        clearInterval(newInterval);
        setTimerIntervalRef(null);
      }
    }, 1000);

    // Store the interval ID in state for later access
    setTimerIntervalRef(newInterval);

    // Return cleanup function
    return () => {
      clearInterval(newInterval);
      setTimerIntervalRef(null);
    };
  }


  const [classid, setClassid] = useState();

  const location = useLocation();

  useEffect(() => {
    if (typeof id !== "undefined") {
      console.log(id, "HERE IS AM OBJECT1")
      const docRef = doc(firebase, "users", id);

      const docData = getDoc(docRef).then((docSnap) => {
        if (docSnap.exists()) {
          let object = docSnap.data();
          console.log("Personal data:", object,  " Personal Data");
          setPersonaldata(object);
          setGclassroomid5(object.googleclassroomid);
          setNameinobject2(object.localfirstname);

        }
      });
    }
  }, [id]);

  useEffect(() => {
    if (typeof id !== "undefined") {
      console.log(id, "HERE IS AM OBJECT3")
      const docRef = doc(firebase, "users", id);

      const docData = getDoc(docRef).then((docSnap) => {
        if (docSnap.exists()) {
          let object = docSnap.data();
          console.log("HERE IS AM OBJECT4", object, object.googleclassroomid);
          setPersonaldata(object);
          setGclassroomid5(object.googleclassroomid);
          setNameinobject2(object.localfirstname);

        }
      });
    }
  }, []);

  useEffect(() => {

    if (typeof activeid !== "undefined" && typeof personaldata === "undefined") {

      if (typeof personaldata[activeid] != "undefined") {
        const dude = personaldata[activeid].listofpasstimes;

        if (typeof dude != "undefined") {
          let sevendaysago = Date.now() - 604800000;
          let temparray = [];

          dude.forEach((obj) => {
            console.log(obj, "1HHIIIII");
            if (obj > sevendaysago) {
              temparray.push(obj);
            } else {
              console.log("Not inclurded");
            }
          });

          console.log(temparray, "HHEEEEHE");
          setNumberofpasses(temparray);
        } else {
          setNumberofpasses([]);
        }

        const ovunder = personaldata[activeid].overunder;
        const allowed = personaldata[activeid].passesallowedinweekifonpenalty;

        setTotalallowed(allowed);
        setOverunderr(ovunder);
      }
    }
  }, [personaldata, activeid]);

  useEffect(() => {
    if (typeof school != "undefined" && typeof state != "undefined" && typeof town != "undefined") {
      findschoollisting();
    }
  }, [school, state, town]);

  useEffect(() => {
    if (typeof timeofreturn != "undefined" && typeof expectedtimeofreturn != "undefined") {
      console.log("Time values:",
        timeofreturn,
        expectedtimeofreturn);
    }
  }, [timeofreturn, expectedreturn]);

  useEffect(() => {
    if (typeof whenpassbegan != "undefined" && passismade == true) {
      begintimer(whenpassbegan);
    }
  }, [whenpassbegan, passismade]);

  useEffect(() => {
    const minutes = Math.floor(secondssince / 60);
    const seconds = secondssince % 60;
    setStringwhichshowsminutesandseconds(`${minutes}:${seconds < 10 ? "0" : ""}${seconds}`);
  }, [secondssince]);

  useEffect(() => {
    if (typeof allclassdata !== "undefined" && allclassdata !== null) {
      console.log("all class data:", allclassdata);

    }
  }, [allclassdata]);

  useEffect(() => {
    if (destination != "") {
      console.log("Destination was just set:", destination);
      setrecordofpasses();
    }
  }, [destination]);

  async function findschoollisting() {
    console.log("Revise Stats was run");
    const q = query(
      collection(firebase, "schools"),
      where("state", "==", state),
      where("town", "==", town),
      where("school", "==", school)
    );

    const snapshot1 = await getCountFromServer(q);
    const totalCount = snapshot1.data().count;
    console.log("qrcode  4  call", totalCount);

    if (totalCount == 1) {
      const querySnapshot = await getDocs(q).then(async (snapshot1) => {
        snapshot1.forEach((doc) => {
          setGetschoolid(doc.data().id);
          console.log(doc.data().id, "This is the school ID ");
        });
      });
    } else {
      setGetschoolid("");
    }
  }

  useEffect(() => {
    if (typeof currentpass !== "undefined" && currentpass !== null) {
      console.log("all pass data:", currentpass);

      setWhenpassbegan(currentpass.timepassinitiated);
      setCurrentdate(currentpass.dateofpass);
      setPassismade(true);
      setRealtimeleave(currentpass.passdetailrealtimeleave);
      setRealtimereturn(currentpass.expectedtimeofarrival);
      setAllottedtime(currentpass.timeallowedonpass);
      setDestination(currentpass.destination);
      setMakeapass(true);
      setPassid(currentpass.id);
      setBathroomtime(currentpass.timeallowedonpass);
      setDrinktime(currentpass.timeallowedonpass);
      setOthertime(currentpass.timeallowedonpass);
      setLeftclass(currentpass.leftclass);

    }
  }, [currentpass]);

  useEffect(() => {
    if (typeof personaldata !== "undefined") {
      console.log(personaldata.passexists, personaldata.role, "These are the passed values in MainMenuStudents.js");
      setId2(personaldata.id);
      setRole2(personaldata.role);
      setFirstname(personaldata.localfirstname);
      setLastname(personaldata.locallastname);
      setEmail(personaldata.email);
      setPhone(personaldata.phonenumber);
      setPnumber(personaldata.phonenumber);
      setSchool(personaldata.school);
      setTown(personaldata.town);
      setState(personaldata.state);
      setPassexists(personaldata.passid ? personaldata.passid : "")
      setLanguage2(personaldata.language)
      setParentlanguage2(personaldata.parentlanguage)
      setLanguagecode2(personaldata.languagecode)
      setParentlanguagecode2(personaldata.parentlanguagecode)
      setNotificationid("12345");
      setGotteachernotificationid("1234");
      setSchool(personaldata.school);
      setTown(personaldata.town);
      setState(personaldata.state);
      setPhotoUrl(personaldata.photoUrl);

      setParentemail(personaldata.parentemail);
      setStudentemail(personaldata.email);

    }
  }, [personaldata]);

  useEffect(() => {
    if (typeof passexists != "undefined" && passexists != "") {
      console.log(
        passexists,
        "the pass was just found!!!!!!!!!!!!!!!!!!!"
      );
      getpassdetails();
    }
  }, [passexists]);


  const getpassdetails = () => {
    console.log(passexists, "This is the pass we are looking at");

    if (typeof passexists != "undefined" && passexists != "") {
      const docRef = doc(firebase, "passes", passexists);

      const docData = getDoc(docRef).then((docSnap) => {
        if (docSnap.exists()) {
          let object = docSnap.data();
          setCurrentpass(object);

        }
      });
    }
  };

  //Example to send with dp

  const navigate = useNavigate();
  // navigate(newidforstudent1, { state: { personaldata } });



  useEffect(() => {
    const checkDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isPhoneOrTablet =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

      const isSmallScreen = window.innerWidth <= 768; // Adjust breakpoint as needed

      setIsMobile(isPhoneOrTablet || isSmallScreen);
    };

    checkDevice();

    // Optional: Add a resize listener to handle screen size changes
    window.addEventListener("resize", checkDevice);

    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);


  const auth = getAuth();

  async function signout() {
    auth.signOut();
    setId2();

    navigate("/");
  }


  // Function to find the next upcoming birthday from studentIds array
  const findNextBirthday = (studentIds) => {
    console.log("=== findNextBirthday CALLED ===");
    console.log("studentIds received:", studentIds);
    console.log("studentIds type:", typeof studentIds);
    console.log("Is Array?", Array.isArray(studentIds));

    if (!Array.isArray(studentIds) || studentIds.length === 0) {
      console.log("❌ EARLY RETURN: studentIds is not an array or is empty");
      return { dateofbirth: "01/01/2027", firstName: "", lastName: "" };
    }

    console.log("✓ studentIds is valid array with", studentIds.length, "students");

    const today = new Date();
    const currentYear = today.getFullYear();

    console.log("Today's Date:", today.toDateString());

    let nextBirthday = null;
    let minDaysDiff = Infinity;
    let processedCount = 0;
    let skippedCount = 0;

    studentIds.forEach((student, index) => {
      console.log(`\n--- Processing student ${index} ---`);
      console.log("Student object:", student);

      if (!student.dateofbirth) {
        console.log("⚠️  SKIPPED: No dateofbirth property");
        skippedCount++;
        return; // Skip if no DOB
      }

      console.log("✓ dateofbirth found:", student.dateofbirth);

      // Parse MM/DD/YYYY format
      const dobParts = student.dateofbirth.split("/");
      console.log("DOB parts:", dobParts);

      if (dobParts.length !== 3) {
        console.log("❌ SKIPPED: Invalid format (expected 3 parts, got", dobParts.length, ")");
        skippedCount++;
        return; // Invalid format
      }

      const dobMonth = parseInt(dobParts[0], 10);
      const dobDay = parseInt(dobParts[1], 10);
      const dobYear = parseInt(dobParts[2], 10);

      console.log("Parsed - Month:", dobMonth, "Day:", dobDay, "Year:", dobYear);

      // Create Date objects for comparison (use current year for birthday)
      const birthdayThisYear = new Date(currentYear, dobMonth - 1, dobDay);
      console.log("Birthday this year would be:", birthdayThisYear.toDateString());

      // Calculate days until this birthday
      let daysDiff;
      if (birthdayThisYear >= today) {
        // Birthday is later this year or today
        daysDiff = Math.ceil((birthdayThisYear - today) / (1000 * 60 * 60 * 24));
        console.log("✓ Birthday is this year or today. Days diff:", daysDiff);
      } else {
        // Birthday was earlier this year, so calculate for next year
        const birthdayNextYear = new Date(currentYear + 1, dobMonth - 1, dobDay);
        daysDiff = Math.ceil((birthdayNextYear - today) / (1000 * 60 * 60 * 24));
        console.log("✓ Birthday has passed this year. Calculating for next year. Days diff:", daysDiff);
      }

      // Find the closest upcoming birthday
      if (daysDiff >= 0 && daysDiff < minDaysDiff) {
        console.log("✓ NEW CLOSEST BIRTHDAY! daysDiff:", daysDiff, "was minDaysDiff:", minDaysDiff);
        minDaysDiff = daysDiff;
        nextBirthday = {
          dateofbirth: student.dateofbirth,
          firstName: student.firstName || "",
          lastName: student.lastName || ""
        };
        console.log("Updated nextBirthday:", nextBirthday);
      } else {
        console.log("Not closest (daysDiff:", daysDiff, "minDaysDiff:", minDaysDiff, ")");
      }

      processedCount++;
    });

    console.log("\n=== AFTER LOOP ===");
    console.log("Processed:", processedCount, "Skipped:", skippedCount);
    console.log("nextBirthday after loop:", nextBirthday);

    // If no upcoming birthday found, return the first one chronologically
    if (!nextBirthday) {
      console.log("❌ No birthday found, searching for earliest birthday chronologically...");
      // Sort by month/day and get the first one
      const sorted = studentIds
        .filter((s) => {
          const hasDOB = !!s.dateofbirth;
          console.log("Filter check - student has dateofbirth?", hasDOB, "DOB:", s.dateofbirth);
          return hasDOB;
        })
        .sort((a, b) => {
          const aParts = a.dateofbirth.split("/");
          const bParts = b.dateofbirth.split("/");
          const aMonthDay = parseInt(aParts[0], 10) * 100 + parseInt(aParts[1], 10);
          const bMonthDay = parseInt(bParts[0], 10) * 100 + parseInt(bParts[1], 10);
          console.log("Sort compare: a monthday:", aMonthDay, "b monthday:", bMonthDay);
          return aMonthDay - bMonthDay;
        });

      console.log("Sorted students:", sorted.length);

      if (sorted.length > 0) {
        nextBirthday = {
          dateofbirth: sorted[0].dateofbirth,
          firstName: sorted[0].firstName || "",
          lastName: sorted[0].lastName || ""
        };
        console.log("✓ Found earliest birthday:", nextBirthday);
      } else {
        console.log("❌ No valid birthdates found at all");
      }
    }

    const result = nextBirthday || { dateofbirth: "01/01/2027", firstName: "", lastName: "" };
    console.log("=== RETURNING ===");
    console.log("Final result:", result);
    return result;
  };

  useEffect(() => {
    console.log("=== SELECTEDCLASS USEEFFECT TRIGGERED ===");
    console.log("selectedclass:", selectedclass);
    console.log("selectedclass type:", typeof selectedclass);

    if (typeof selectedclass != "undefined") {
      console.log("✓ PASSED: selectedclass is defined");

      setActiveid(selectedclass.id);
      setActivestudentlist(selectedclass.students);
      setActivename(selectedclass.classname);
      setActiveperiod(selectedclass.period);
      setGclassroomid(selectedclass.googleclassroomid);
      setGclassroomname(selectedclass.googleclassroomname);

      setTeacherid(selectedclass.teacherid);

      setBathroomtime(selectedclass.timelimitbathroompass);
      setDrinktime(selectedclass.drinkofwater)
      setOthertime(selectedclass.timelimitnonbathroompass)

      setCoursename(selectedclass.classname);
      setCurrentlocation(selectedclass.location);
      setTeacheridforreturn(selectedclass.teacherid);
      setTeacher(selectedclass.teacheriscalled);

      setClassid(selectedclass.id);

      setLocalclosewebpass(!!selectedclass.closewebpass);

      let classe = selectedclass.classname;
      let idselect = selectedclass.key;
      let gcid = selectedclass.googleclassroomid;
      let studentsss = selectedclass.students;
      let courseId = selectedclass.googleclassroomname;

      localStorage.setItem("activeid", selectedclass.id);
      localStorage.setItem("activename", selectedclass.classname);
      localStorage.setItem("activeperiod", selectedclass.period);
      localStorage.setItem("gclassroomid", selectedclass.googleclassroomid);
      localStorage.setItem("gclassroomname", selectedclass.googleclassroomname);

      console.log(selectedclass.classname, "selected class");

      // Use pre-calculated birthday info for this class
      console.log("\n===== BIRTHDAY SECTION START =====");
      console.log("Step 1 - Checking for pre-calculated birthday info");
      console.log("Class ID:", selectedclass.id);
      console.log("classessBirthdayInfo:", classessBirthdayInfo);

      const preCalculatedBirthday = classessBirthdayInfo[selectedclass.id];

      if (preCalculatedBirthday) {
        console.log("✓ FOUND: Pre-calculated birthday info");
        console.log("Pre-calculated data:", preCalculatedBirthday);

        console.log("\nStep 2 - Setting state variables from pre-calculated data");
        setNextbirthday(preCalculatedBirthday.dateofbirth);
        setNextBirthdayFirstName(preCalculatedBirthday.firstName);
        setNextBirthdayLastName(preCalculatedBirthday.lastName);

        console.log("✓ State updated");
        console.log("  dateofbirth:", preCalculatedBirthday.dateofbirth);
        console.log("  firstName:", preCalculatedBirthday.firstName);
        console.log("  lastName:", preCalculatedBirthday.lastName);
      } else {
        console.log("⚠️  WARNING: No pre-calculated birthday found for this class");
        console.log("  Attempting fallback calculation with studentIds");

        if (selectedclass.studentIds && Array.isArray(selectedclass.studentIds)) {
          console.log("✓ studentIds available, calculating now");
          const nextBirthdayInfo = findNextBirthday(selectedclass.studentIds);
          setNextbirthday(nextBirthdayInfo.dateofbirth);
          setNextBirthdayFirstName(nextBirthdayInfo.firstName);
          setNextBirthdayLastName(nextBirthdayInfo.lastName);
          console.log("✓ Fallback calculation completed and state updated");
        } else {
          console.log("❌ FAILED: No studentIds found for fallback");
        }
      }
      console.log("===== BIRTHDAY SECTION END =====\n");
    } else {
      console.log("❌ FAILED: selectedclass is undefined");
    }
  }, [selectedclass, classessBirthdayInfo]);


  // useEffect(() => {
  //   if (typeof currentstudent != "undefined") {
  //     setStudentidd(currentstudent.id);
  //     setParentlanguagecode(currentstudent.parentlanguagecode);
  //   }
  // }, [currentstudent]);

  useEffect(() => {
    if (
      typeof activeid != "undefined" &&
      activeid != "123" &&
      typeof activestudentlist2 != "undefined"
    ) {
      // filter sstudnets from this class
      console.log(activestudentlist2, "YO", activeid, "this is the active id");

      let current = activestudentlist2.filter((person) =>
        person.classlist.includes(activeid)
      );

      setCurrentclass(current);

    }
  }, [activeid]);

  useEffect(() => {
    console.log("HERE IS AM OBJECT5", gclassroomid5);
    if (
      typeof activeid !== "undefined" &&
      activeid !== "123" &&
      typeof allclassdata !== "undefined"
    ) {
      console.log(gclassroomid5, "Is this the gclassroomid5?");
      // Find the class object with id === activeid
      const object = allclassdata.find(cls => cls.id === activeid);
      if (object) {
        console.log(showGradesButtonLogPrefix, "Active class found", {
          activeid,
          classname: object.classname,
          hasGc1datasent: Array.isArray(object.gc1datasent),
          gc1datasentLength: Array.isArray(object.gc1datasent) ? object.gc1datasent.length : undefined,
        });
        console.log("HERE IS AM OBJECT6", gclassroomid5, object.gc1datasent);
        setGc1compare2(object.gc1compare);

        if (Array.isArray(object.gc1datasent)) {
          object.gc1datasent.sort((a, b) => {
            const gradeA = a?.grade ?? Number.POSITIVE_INFINITY;
            const gradeB = b?.grade ?? Number.POSITIVE_INFINITY;
            return gradeB - gradeA;
          });
        }
        setGc1datasent2(object.gc1datasent);
        setGc1timesent2(object.gc1timesent);
        setGc1title2(object.gc1title);
        setGccompare2(object.gccompare);

        if (object.gc1datasent) {
          console.log(showGradesButtonLogPrefix, "Raw gc1datasent", object.gc1datasent);
          console.log("gc1datasent:", object.gc1datasent);
          console.log("gclassroomid5:", gclassroomid5);
          const grades = Array.isArray(object.gc1datasent)
            ? object.gc1datasent
              .map(i => typeof i.grade === "number" ? i.grade : null)
              .filter(g => g !== null)
            : [];
          const gradesNoZero = grades.filter(g => g !== 0);
          const computedHighscore = grades.length > 0 ? Math.max(...grades) : undefined;
          const computedAverageNoZero = gradesNoZero.length > 0
            ? gradesNoZero.reduce((a, b) => a + b, 0) / gradesNoZero.length
            : undefined;

          console.log(showGradesButtonLogPrefix, "Computed grade stats", {
            grades,
            gradesNoZero,
            highscore2: computedHighscore,
            averageofgrades2: computedAverageNoZero,
          });

          object.gc1datasent.forEach(item => {
            console.log("Checking item.id:", item.id);
            // Find high and low scores
            if (Array.isArray(object.gc1datasent)) {
              const grades = object.gc1datasent
                .map(i => typeof i.grade === "number" ? i.grade : null)
                .filter(g => g !== null);

              if (grades.length > 0) {
                setHighscore2(Math.max(...grades));
                const gradesAboveZero = grades.filter(g => g > 0);
                if (gradesAboveZero.length > 0) {
                  setLowscore2(Math.min(...gradesAboveZero));
                } else {
                  setLowscore2(undefined);
                }
              } else {
                setHighscore2(undefined);
                setLowscore2(undefined);
              }
            }
            // Calculate averages for gc1datasent
            if (Array.isArray(object.gc1datasent)) {
              const grades = object.gc1datasent
                .map(i => typeof i.grade === "number" ? i.grade : null)
                .filter(g => g !== null);

              // Average including zeros
              if (grades.length > 0) {
                const avgWithZeros = grades.reduce((a, b) => a + b, 0) / grades.length;
                setAverageofgradeswithzeros2(avgWithZeros);
              } else {
                setAverageofgradeswithzeros2(undefined);
              }

              // Average excluding zeros
              const gradesNoZero = grades.filter(g => g !== 0);
              if (gradesNoZero.length > 0) {
                const avgNoZero = gradesNoZero.reduce((a, b) => a + b, 0) / gradesNoZero.length;
                setAverageofgrades2(avgNoZero);
              } else {
                setAverageofgrades2(undefined);
              }
            }

            if (item.id === gclassroomid5) {
              console.log(item, item.grade, "This is the item and grade in object");
              setSelectedclass12(item);
              setGradeReceived2(item.grade);
            }
          });
        } else {
          console.log(showGradesButtonLogPrefix, "No gc1datasent found on active class", {
            activeid,
            classname: object.classname,
            gc1datasent: object.gc1datasent,
          });
        }

        // Sort gcdatasent by summary.averageGrade (lowest to highest)
        if (Array.isArray(object.gcdatasent)) {
          object.gcdatasent.sort((a, b) => {
            const gradeA = a?.summary?.averageGrade ?? Number.POSITIVE_INFINITY;
            const gradeB = b?.summary?.averageGrade ?? Number.POSITIVE_INFINITY;
            return gradeB - gradeA;
          });
        }

        setGcdatasent2(object.gcdatasent);

        if (object.gcdatasent) {
          object.gcdatasent.forEach(item => {
            if (
              (item.profile && item.profile.firebasestudentid === gclassroomid) ||
              (item.profile && item.profile.firebasestudentid === id)
            ) {
              setSelectedclass2(item);
            }
          });
        }

        setGctimesent2(object.gctimesent);

        console.log(object.gc1compare);
        console.log(object.gc1datasent);
        console.log(object.gc1timesent);
        console.log(object.gccompare);
        console.log(object.gcdatasent);
        console.log(object.gctimesent);
      } else {
        console.log(showGradesButtonLogPrefix, "No class found in allclassdata for activeid", {
          activeid,
          allclassdataLength: Array.isArray(allclassdata) ? allclassdata.length : undefined,
        });
      }
    } else {
      console.log(showGradesButtonLogPrefix, "Grade calculation prerequisites not met", {
        activeid,
        allclassdataDefined: typeof allclassdata !== "undefined",
        gclassroomid5,
      });
    }
  }, [activeid, allclassdata, gclassroomid5]);

  useEffect(() => {
    if (
      typeof destination != "undefined"
    ) {
      setLocationdestination(destination)

    }

    if (destination == "Bathroom") {
      setAllottedtime(bathroomtime)
    }
    else if (destination == "Get Drink of Water") {
      setAllottedtime(drinktime)
    }
    else {
      setAllottedtime(othertime)
    }

  }, [destination, bathroomtime, drinktime, othertime]);

  useEffect(() => {
    if (
      typeof allottedtime != "undefined"
    ) {
      console.log(allottedtime, "does it have this?");
    }

  }, [allottedtime]);

  const cardData = ["hello", "goodbye", "hii"];
  async function signout() {
    auth.signOut();
    setId2();

    navigate("/");
  }

  // Helper function to check if auth tokens are valid
  useEffect(() => {
    // First check if location.state exists
    if (typeof id != "undefined") {
      getclasses();
    }
  }, [id]);

  useEffect(() => {
    // First check if location.state exists
    if (destination != "" && (destination == "Bathroom" || destination == "Get Drink of Water" || destination == "Nurse")) {
      console.log("Destination was just set to a preset value");
      setCustom(false);
    }
  }, [destination]);

  useEffect(() => {
    if (custom == true) {
      if (destination == "Bathroom" || destination == "Get Drink of Water" || destination == "Nurse") {
        setDestination(""); // Consider removing this line or replacing with a default value
      }
    }
  }, [custom]);

  async function getclasses() {
    try {
      if (!id) {
        console.error("No valid student ID found in location state");
        alert("Student ID is missing. Please log in again.");
        return;
      }

      const f = query(
        collection(firebase, "classesbeingtaught"),
        where("students", "array-contains", id)
      );

      const querySnapshot = await getDocs(f);

      if (querySnapshot.empty) {
        alert("Try signing in again to see if you are enrolled in any classes");
        navigate("/SignIn2");  // Navigate to SignIn2
        return;
      }

      const array2 = [];
      const arrayofclasses = [];
      const birthdayInfoByClass = {};

      querySnapshot.forEach((doc) => {

        let classes = doc.data();

        let user = {
          key: doc.data().id,
          classname: doc.data().classname,
          period: doc.data().period,
          students: doc.data().students,
          googleclassroomid: doc.data().googleclassroomid ? doc.data().googleclassroomid : "",
          googleclassroomname: doc.data().googleclassroomname ? doc.data().googleclassroomname : "",
          closewebpass: doc.data().closewebpass ? doc.data().closewebpass : false,
        };

        array2.push(user);
        arrayofclasses.push(classes);

        // Pre-calculate birthday for this class
        if (doc.data().studentIds && Array.isArray(doc.data().studentIds)) {
          console.log(`\nPre-calculating birthday for class: ${doc.data().classname}`);
          const birthdayInfo = findNextBirthday(doc.data().studentIds);
          birthdayInfoByClass[doc.data().id] = birthdayInfo;
          console.log(`Stored birthday for class ${doc.data().id}:`, birthdayInfo);
        }
      });

      localStorage.setItem("myclasses", JSON.stringify(array2));
      setTemparray(array2);
      setAllclassdata(arrayofclasses);
      setClassesBirthdayInfo(birthdayInfoByClass);
      console.log("\n=== ALL CLASS BIRTHDAYS PRE-CALCULATED ===");
      console.log("Total classes processed:", array2.length);
      console.log("Birthday info stored:", birthdayInfoByClass);
    } catch (error) {
      console.error("Error fetching classes:", error.message || error);
      alert("Failed to fetch classes. Please check the console for details.");
    }
  }

  // Update the signout function to also clear userState
  async function signout() {
    auth.signOut();
    setId2();
    // Clear localStorage
    const keys = [
      'id', 'id2', 'firstname', 'firstname2', 'lastname', 'lastname2',
      'role', 'role2', 'school', 'school2', 'town', 'town2',
      'state', 'state2', 'email', 'email2', 'phone', 'phone2'
    ];
    keys.forEach(key => localStorage.removeItem(key));

    navigate("/");
  }

  async function setrecordofpasses() {
    console.log("Getnumberofrecentpasses was run");
    const time = Date.now() - 604800000;
    const tenweeks = Date.now() - 6048000000;
    const array = [];

    try {
      if (typeof id != "undefined" && typeof activeid != "undefined") {
        console.log("YOYO");

        const q = query(
          collection(firebase, "passes"),
          where("classid", "==", activeid),
          where("studentid", "==", id),
          where("returned", ">", tenweeks),
          orderBy("returned", "desc")
        );

        const snapshot1 = await getCountFromServer(q);
        const totalCount = snapshot1.data().count;
        console.log("2 This is the totalcount in classse", totalCount);

        let array23 = [];
        let numberthatarerecent = 0;

        const querySnapshot = await getDocs(q)

          .then(async (snapshot1) => {

            snapshot1.forEach(doc => {

              if (doc.data().returned > tenweeks) {
                let datatobesaved = { "passid": doc.data().id, "overunder": doc.data().differenceoverorunderinminutes, "timeended": doc.data().returned };
                array23.push(datatobesaved);
              }

              if (doc.data().returned > time) {
                numberthatarerecent = numberthatarerecent + 1;
              }

            })

            updateDoc(doc(firebase, "users", id), {
              [`${activeid}.passdetails`]: array23,
            }).catch((error) => {
              console.log(error);
              alert(error);
            });
          })

      }
    } catch (error) {
      console.error("Error fetching passes:", error);
      alert("There was an error fetching passes: " + error.message);
    }
  }







  async function handleBarCodeScanned23() {
    console.log(passexists, "passexists", currentdate, "currentdate", destination, "destination", "makepass", makeapass, "end this pass")
    try {
      if (passexists != "" && currentdate != "" && destination != "" && makeapass == true) {
        const nowTime = Date.now();
        const quickCloseThreshold = leftclass + 60000;
        const isQuickCloseDelete = typeof leftclass === "number" && nowTime <= quickCloseThreshold;

        console.log("[Quick Close Check][Student Return] Evaluating return path", {
          passId: passid,
          studentId: id,
          classId: activeid,
          leftclass,
          nowTime,
          quickCloseThreshold,
          isQuickCloseDelete,
        });

        if (isQuickCloseDelete) {
          console.log("[Quick Close Delete] Deleting student pass before normal return flow", {
            passId: passid,
            studentId: id,
            classId: activeid,
            leftclass,
            nowTime,
          });

          if (getschoolid != "") {
            await updateDoc(doc(firebase, "schools", getschoolid), {
              update: nowTime,
            });
          }

          await updateDoc(doc(firebase, "users", id), {
            passid: "",
            status: "",
          });

          if (teacherid) {
            await updateDoc(doc(firebase, "users", teacherid), {
              addingnumber: nowTime,
              idofstudent: id,
              passnumber: passid,
            });
          }

          await deleteDoc(doc(firebase, "passes", passid));

          setPersonaldata(prev => prev ? {
            ...prev,
            passid: "",
            status: "",
          } : prev);
          setCurrentpass(undefined);
          setSummary(false);
          setPassismade(false);
          setSecondssince(0);
          setWhenpassbegan(0);
          setStringwhichshowsminutesandseconds("0:00");
          setPassexists("");
          setCurrentdate("");
          setDestination("");
          setCustom(false);
          setMakeapass(false);
          setTimeofreturn(0);
          setExpectedtimeofreturn(0);
          setShowspinner(false);

          if (timerIntervalRef) {
            clearInterval(timerIntervalRef);
            setTimerIntervalRef(null);
          }

          return;
        }

        console.log("[Quick Close Retain][Student Return] Pass retained and continuing through normal return flow", {
          passId: passid,
          studentId: id,
          classId: activeid,
          leftclass,
          nowTime,
        });

        console.log("1Checking");

        setTimeofreturn(nowTime);
        setSummary(true);

        const nowwwwwww = nowTime;
        const joe = nowTime;
        const expectedreturn = ((allottedtime * 60000) + leftclass);
        setExpectedtimeofreturn((allottedtime * 60000) + leftclass);
        const current = numberofpasses;

        console.log("2Checking");

        let arrayy3 = [];

        if (typeof current != "undefined") {
          arrayy3 = current;
          arrayy3.push(joe);
        } else {
          arrayy3 = [];
          arrayy3.push(joe);
        }

        if (getschoolid != "") {
          await updateDoc(doc(firebase, "schools", getschoolid), {
            update: nowwwwwww,
          });
        }

        var r = new Date();
        const currentdiff = (expectedreturn - joe) / 60000;
        const whatever = Math.round((allottedtime - currentdiff) * 10) / 10;

        const passdetails = { overunder: currentdiff, timeended: joe, passid: passid }

        setShowspinner(false);

        // Update the pass record
        await updateDoc(doc(firebase, "passes", passid), {
          returned: joe,
          timereturned: r.toLocaleTimeString([], {
            hour12: true,
            timeStyle: "short",
          }),
          returnedbeforetimelimit: currentdiff === 0 || currentdiff > 0,
          differenceoverorunderinminutes: currentdiff
        });

        // Update the user record
        await updateDoc(doc(firebase, "users", id), {
          [`${activeid}.notlateonhallpaass`]: currentdiff === 0 || currentdiff > 0,
          [`${classid}.passdetails`]: arrayUnion(passdetails),
          ...(currentdiff < 0 ? {
            [`${classid}.lastmistake`]: "Late On A Pass",
            [`${classid}.lastmistaketime`]: Date.now(),
          } : {}),
          passid: "",
          status: "",
        });

        // Update local personaldata state so the modal reflects the new pass immediately
        setPersonaldata(prev => {
          if (!prev) return prev;
          const classEntry = prev[classid] ?? {};
          const existingPassDetails = Array.isArray(classEntry.passdetails) ? classEntry.passdetails : [];
          return {
            ...prev,
            [classid]: {
              ...classEntry,
              passdetails: [...existingPassDetails, passdetails],
              notlateonhallpaass: currentdiff === 0 || currentdiff > 0,
              ...(currentdiff < 0 ? {
                lastmistake: "Late On A Pass",
                lastmistaketime: Date.now(),
              } : {}),
            }
          };
        });

        // Update the teacher record
        await updateDoc(doc(firebase, "users", teacherid), {
          addingnumber: nowwwwwww,
          idofstudent: id,
          passnumber: passid
        });

        // Clean up timers and state
        if (timerIntervalRef) {
          clearInterval(timerIntervalRef);
          setTimerIntervalRef(null);
        }

        setTimeout(() => {
          setSelectedclass("");
          setSummary(false);
          setPassismade(false);
          setSecondssince(0);
          setWhenpassbegan(0);
          setStringwhichshowsminutesandseconds("0:00");
          setPassexists("");
          setCurrentdate("");
          setDestination("");
          setCustom(false);
          setMakeapass(false);
          setTimeofreturn(0);
          setExpectedtimeofreturn(0);
        }, 6000);
      }
    } catch (error) {
      console.error("Error returning pass:", error);
      console.log("Error returning pass:", error);
      alert("There was a problem returning the pass: " + error.message);

      // Reset spinner state in case of error
      setShowspinner(false);
    }
  }

  const handleBarCodeScanned = () => {
    console.log("Pass started")
    var r = new Date();
    var s = Date.now();

    setRightnow(s);
    setLeavetimeGlobal(r);
    setLeftclass(s);
    setWhenpassbegan(s);
  };

  useEffect(() => {
    if (leavetimeGlobal) {
      const formatAMPM = () => {
        let hours = leavetimeGlobal.getHours();
        let minutes = leavetimeGlobal.getMinutes();
        let ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes.toString().padStart(2, "0");
        let strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      };

      const p = formatAMPM(leavetimeGlobal);

      setRealtimeleave(p);
      setCurrentdate(
        leavetimeGlobal.getMonth() +
        1 +
        "/" +
        leavetimeGlobal.getDate() +
        "/" +
        leavetimeGlobal.getFullYear()
      );


      if (typeof allottedtime === "number" && allottedtime > 0) {
        // Calculate expected return time by adding allottedtime (in minutes) to leavetimeGlobal
        const expectedReturn = new Date(leavetimeGlobal.getTime() + allottedtime * 60000);
        const formatAMPM = (date) => {
          let hours = date.getHours();
          let minutes = date.getMinutes();
          let ampm = hours >= 12 ? "pm" : "am";
          hours = hours % 12;
          hours = hours ? hours : 12;
          minutes = minutes.toString().padStart(2, "0");
          return hours + ":" + minutes + " " + ampm;
        };
        setRealtimereturn(formatAMPM(expectedReturn));
      } else {
        setRealtimereturn("");
      }
    }

  }, [leavetimeGlobal]);

  useEffect(() => {
    console.log("selectedclass changed:", selectedclass);
  }, [selectedclass]);


  useEffect(() => {

    if (typeof day === "undefined" && currentdate != "") {
      finalizehallpass();
      console.log(getschoolid, "does it have this?")
    }
  }, [currentdate]);

  async function finalizehallpass() {
    if (allottedtime > 0 && passexists == "" && destination != "") {
      const nowww = Date.now();
      const expected = nowww + (allottedtime * 60000);
      const nowwwwwww = Date.now();


      if (typeof getschoolid != "undefined") {
        await updateDoc(doc(firebase, "schools", getschoolid), {
          update: nowwwwwww,
        }).catch((error) => {
          console.log(error);
          alert(error);
        });
      }

      try {

        const docRef = await addDoc(collection(firebase, "passes"), {
          studentPhotoUrl: photoUrl ? photoUrl : "",
          dateofpass: currentdate ? currentdate : "",
          expectedtimeofarrival: realtimereturn ? realtimereturn : "",
          timepassinitiated: nowww,
          timeallowedonpass: allottedtime ? allottedtime : "",
          linkedclass: linkedclass ? linkedclass : "",
          language: language2 ? language2 : "",
          parentlanguage: parentlanguage2 ? parentlanguage2 : "",
          languagecode: languagecode2 ? languagecode2 : "",
          parentlanguagecode: parentlanguagecode2 ? parentlanguagecode2 : "",
          firstname: firstname ? firstname : "",
          lastname: lastname ? lastname : "",
          classid: activeid ? activeid : "",
          coursename: coursename ? coursename : "",
          comingfrom: currentlocation ? currentlocation : "",
          teacherid: teacherid ? teacherid : "",
          notificationid: typeof notificationid != "undefined" ? notificationid : 0,
          teachernotificationid: typeof gotteachernotificationid != "undefined" ? gotteachernotificationid : 0,
          returnteacherid: teacheridforreturn ? teacheridforreturn : "",
          classesinvolved: activeid ? [activeid] : [],
          teachersinvolved: teacherid ? [teacherid] : [],

          studentid: id ? id : "",
          school: school ? school : "",
          town: town ? town : "",
          state: state ? state : "",
          teacheriscalled: teacher ? teacher : "",
          destination: destination ? destination : "",
          timeleftclass: realtimeleave ? realtimeleave : "",
          leftclass: nowww,
          returned: 0,
          timereturned: 0,
          whenlimitwillbereached: 0,
          // returnedbeforetimelimit: "null",
          differenceoverorunderinminutes: 0,

          phonenumber: Array.isArray(pnumber) ? pnumber : pnumber ? [pnumber] : [],
          studentisenrolled: typeof iamenrolled2 != "undefined" ? iamenrolled2 : "",

          studentemail: studentemail ? studentemail : "",
          parentemail: parentemail ? parentemail : "",

        }).then(async (userRec) => {

          console.log("2", "THIS HAPpened");

          setPassid(userRec.id);
          let user = userRec.id;
          await updateDoc(doc(firebase, "passes", user), {
            id: user,
            leftclass: nowww,
            timeleftclass: leavetimeGlobal.toLocaleTimeString([], {
              hour12: true,
              timeStyle: "short",
            }),
            whenlimitwillbereached: expected,
            passdetailrightnow: nowww,
            passdetailcurrentdate: currentdate,
            passdetailrealtimeleave: realtimeleave,
          }).catch((error) => {
            console.log(error); alert(error);
          });

          await updateDoc(doc(firebase, "users", teacherid), {
            addingnumber: nowww,
            passnumber: userRec.id,
            idofstudent: id,
          }).catch((error) => {
            console.log(error); alert(error);
          });

          await updateDoc(doc(firebase, "users", id), {
            status: "On Pass",
            passid: userRec.id
          }).catch((error) => {
            console.log(error); alert(error);
          });

          setPassexists(userRec.id);
        })

      } catch (error) {
        console.log("adding doc errof", error); alert(error);
      }

      // .catch((error) => {
      //   console.log(error); alert(error);
      // })
      setExpectedreturn(nowww + (allottedtime * 60000));
      setCompleted(true);
      setPassismade(true);

    }
    else if (destination == "") {
      alert("Please select a destination before creating a pass");
    }
  }
  console.log("Ready check details:");
  console.log("gccompare2:", gccompare2);
  console.log("gcdatasent2:", gcdatasent2);
  console.log("gctimesent2:", gctimesent2);
  console.log("gc1title2:", gc1title2);
  console.log("gc1compare2:", gc1compare2);
  console.log("gc1datasent2:", gc1datasent2);
  console.log("gc1timesent2:", gc1timesent2);
  console.log("selectedclass2:", selectedclass2);
  // Make isClassDataReady true if either all the detailed fields are defined OR the minimal set is defined
  const isClassDataReady =
    (
      gc1title2 !== undefined &&
      gc1compare2 !== undefined &&
      gc1datasent2 !== undefined &&
      gc1timesent2 !== undefined
    )
    ||
    (
      gccompare2 !== undefined &&
      gcdatasent2 !== undefined &&
      gctimesent2 !== undefined &&
      selectedclass2 !== undefined
    );

  console.log("isClassDataReady:", isClassDataReady, destination, "Destinations ", passid, "Pass ID");

  useEffect(() => {
    const hiddenReasons = [];

    if (typeof currentclass === "undefined") hiddenReasons.push("currentclass is undefined");
    if (typeof activeid === "undefined") hiddenReasons.push("activeid is undefined");
    if (passexists !== "") hiddenReasons.push(`passexists is '${passexists}'`);
    if (summary === true) hiddenReasons.push("summary is true");
    if (makeapass === true) hiddenReasons.push("makeapass is true");
    if (showgrades === true) hiddenReasons.push("showgrades is already true");
    if (typeof highscore2 === "undefined") hiddenReasons.push("highscore2 is undefined");
    else if (!(highscore2 > 0)) hiddenReasons.push(`highscore2 is ${highscore2}`);
    if (typeof averageofgrades2 === "undefined") hiddenReasons.push("averageofgrades2 is undefined");
    else if (!(averageofgrades2 > 0)) hiddenReasons.push(`averageofgrades2 is ${averageofgrades2}`);

    if (hiddenReasons.length === 0) {
      console.log(showGradesButtonLogPrefix, "Button visible", {
        activeid,
        highscore2,
        averageofgrades2,
      });
    } else {
      console.log(showGradesButtonLogPrefix, "Button hidden", {
        activeid,
        highscore2,
        averageofgrades2,
        hiddenReasons,
      });
    }
  }, [
    activeid,
    currentclass,
    passexists,
    summary,
    makeapass,
    showgrades,
    highscore2,
    averageofgrades2,
  ]);

  useEffect(() => {
    if (typeof activeid !== "undefined" && activeid !== "") {

      [
        { name: "gccompare2", value: gccompare2 },
        { name: "gcdatasent2", value: gcdatasent2 },
        { name: "gctimesent2", value: gctimesent2 },
        { name: "gc1title2", value: gc1title2 },
        { name: "gc1compare2", value: gc1compare2 },
        { name: "gc1datasent2", value: gc1datasent2 },
        { name: "gc1timesent2", value: gc1timesent2 },
        { name: "setSelectedclass2", value: setSelectedclass2 },
        { name: "sid2", value: sid2 },
        { name: "only2studentid2", value: only2studentid2 },
        { name: "studentid2", value: studentid2 },
        { name: "setSid2", value: setSid2 },
        { name: "selectedclass2", value: selectedclass2 },
        { name: "selectedclass12", value: selectedclass12 },
        { name: "setSelectedclass12", value: setSelectedclass12 },
        { name: "setShowpersonal2", value: setShowpersonal2 },
        { name: "showpersonal2", value: showpersonal2 },
        { name: "gradereceived2", value: gradereceived2 },
        { name: "nameinobject2", value: nameinobject2 },
        { name: "googleclassroomid2", value: googleclassroomid2 },
        { name: "averageofgradeswithzeros2", value: averageofgradeswithzeros2 },
        { name: "averageofgrades2", value: averageofgrades2 },
        { name: "lowscore2", value: lowscore2 },
        { name: "highscore2", value: highscore2 }
      ].forEach(({ name, value }) => {
        if (typeof value === "undefined") {
          console.log(`${name} is undefined`);
        }
      });
    }
  }, [activeid, gccompare2, gcdatasent2, gctimesent2, gc1title2, gc1compare2, gc1datasent2, gc1timesent2, sid2, only2studentid2, studentid2, selectedclass2, selectedclass12, showpersonal2, gradereceived2, nameinobject2, googleclassroomid2, averageofgradeswithzeros2, averageofgrades2, lowscore2, highscore2]);

  function renderPassPerformanceModal() {
    if (!showpassperformance) return null;

    const classData = personaldata?.[activeid];
    const behaviorList = classData?.behaviorlist ?? [];
    const penaltyNumber = behaviorList.reduce((sum, entry) => sum + (Number(entry?.amount) || 0), 0);
    const behaviorPercent = 100 + penaltyNumber;

    const passDetailsArr = [...(classData?.passdetails ?? [])].sort((a, b) => (Number(b.timeended) || 0) - (Number(a.timeended) || 0));
    const punctualityScore = Math.round(passDetailsArr.reduce((sum, pd) => sum + (Number(pd?.overunder) || 0), 0) * 10) / 10;

    const lastMistake = classData?.lastmistake ?? "";
    const lastMistakeTime = classData?.lastmistaketime ?? 0;
    const lastMistakeValue = classData?.positiveornegative ?? "";
    const overunderVal = classData?.overunder ?? 0;
    const passesAllowed = classData?.passesallowedinweekifonpenalty;
    const recentPassCount = Array.isArray(numberofpasses) ? numberofpasses.length : 0;
    const fiveDaysAgo = Date.now() - 432000000;

    let feedbackHeader = "";
    let feedbackBody = "";

    if (
      overunderVal < 0 &&
      activeid &&
      typeof passesAllowed !== "undefined" &&
      recentPassCount >= passesAllowed
    ) {
      feedbackHeader = "You cannot get passes now!";
      feedbackBody = `# of Passes Allowed: ${passesAllowed} per week.\nTo undo - make up time with the teacher.`;
    } else if (lastMistake === "Late On A Pass" && lastMistakeTime > fiveDaysAgo) {
      feedbackHeader = "Try to Improve!";
      feedbackBody = "Your Last Misstep:\nTaking Too Much Time On A Hall Pass.";
    } else if (lastMistake === "Late To Class" && lastMistakeTime > fiveDaysAgo) {
      feedbackHeader = "Try to Improve!";
      feedbackBody = "Your Last Misstep:\nShowing Up Late To Class.";
    } else if (lastMistake !== "" && lastMistake !== "Not Specified" && lastMistakeValue < 0 && lastMistakeTime > fiveDaysAgo) {
      feedbackHeader = "Try to Improve!";
      feedbackBody = `Class Standard You Didn't Meet:\n${lastMistake}`;
    } else if (lastMistake !== "" && lastMistake !== "Not Specified" && lastMistakeValue > 0 && lastMistakeTime > fiveDaysAgo) {
      feedbackHeader = "Give Yourself Credit!";
      feedbackBody = `Class Standard You Exceeded:\n${lastMistake}`;
    } else {
      feedbackBody = "According to our records, there is no recent feedback to report.";
    }

    const hasBehavior = behaviorList.length > 0;
    const hasPasses = passDetailsArr.length > 0;

    const inDetailMode = showBehaviorDetail || showPassDetail;
    const modalTitle = showBehaviorDetail ? "Behaviors" : showPassDetail ? "Punctuality" : "Passes/Behaviors";

    return (
      <div
        style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.75)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: inDetailMode ? "pointer" : "default",
        }}
        onClick={inDetailMode ? () => { setShowBehaviorDetail(false); setShowPassDetail(false); setLockedModalHeight(null); } : undefined}
      >
        <div
          ref={modalRef}
          onClick={e => e.stopPropagation()}
          onMouseDown={e => e.stopPropagation()}
          onTouchStart={e => e.stopPropagation()}
          style={{
            backgroundColor: "#000000",
            border: "3px solid #e43522",
            borderRadius: "12px",
            padding: "30px",
            width: "clamp(300px, 60vw, 700px)",
            color: "white",
            fontFamily: "fantasy",
            textAlign: "center",
            height: lockedModalHeight ? lockedModalHeight + "px" : "auto",
            maxHeight: "90vh",
            overflowY: inDetailMode ? "hidden" : "auto",
            boxSizing: "border-box",
            paddingBottom: "30px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ fontSize: "42px", marginBottom: "20px", position: "sticky", top: 0, backgroundColor: "#000", zIndex: 1, paddingTop: "4px", paddingBottom: "4px", marginLeft: "-30px", marginRight: "-30px", paddingLeft: "30px", paddingRight: "30px" }}>{modalTitle}{showPassDetail ? <span style={{ color: punctualityScore >= 0 ? "#00FF00" : "#e43522" }}> {punctualityScore >= 0 ? "+" : ""}{punctualityScore}</span> : null}{showBehaviorDetail ? <span style={{ color: behaviorPercent >= 100 ? "#00FF00" : "#e43522" }}> {behaviorPercent >= 100 ? "+" : ""}{behaviorPercent}</span> : null}</div>

          {inDetailMode ? (
            <>
              {/* Scrollable list content */}
              <div style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                {/* Behavior detail list */}
                {showBehaviorDetail && (
                  <div>
                    {behaviorList.map((entry, i) => {
                      const amt = Number(entry.amount) || 0;
                      const dateStr = entry.time ? new Date(entry.time).toLocaleDateString() : null;
                      return (
                        <div key={i} style={{
                          backgroundColor: "#013469",
                          border: "3px solid #e43522",
                          borderRadius: "8px",
                          padding: "12px",
                          marginBottom: "10px",
                          fontFamily: "sans-serif",
                          textAlign: "center",
                        }}>
                          {dateStr && <div style={{ fontSize: "18px", opacity: 0.7, marginBottom: "6px" }}>{dateStr}</div>}
                          <div style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "6px", color: amt >= 0 ? "#00FF00" : "#e43522" }}>
                            {amt > 0 ? "+" : ""}{entry.amount ?? "0"}
                          </div>
                          {entry.title && (
                            <div style={{ fontSize: "16px" }}>
                              {amt >= 0 ? "Awarded for: " : "Penalized for: "}{entry.title}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Pass detail list */}
                {showPassDetail && (
                  <div>
                    {passDetailsArr.map((pd, i) => {
                      const mins = Math.round((Number(pd.overunder) || 0) * 10) / 10;
                      const timeOpts = { hour: "numeric", minute: "2-digit", hour12: true };
                      const dateStr = pd.timeended
                        ? new Date(pd.timeended).toLocaleDateString()
                        : null;
                      const turnedInTime = pd.timeended
                        ? new Date(pd.timeended).toLocaleTimeString([], timeOpts)
                        : null;
                      const dueTime = pd.timeended
                        ? new Date(pd.timeended + (Number(pd.overunder) || 0) * 60000).toLocaleTimeString([], timeOpts)
                        : null;
                      return (
                        <div key={i} style={{
                          backgroundColor: "#013469",
                          border: "3px solid #e43522",
                          borderRadius: "8px",
                          padding: "12px",
                          marginBottom: "10px",
                          fontFamily: "sans-serif",
                          textAlign: "center",
                        }}>
                          {dateStr && <div style={{ fontSize: "18px", opacity: 0.7, marginBottom: "6px" }}>{dateStr}</div>}
                          {turnedInTime && <div style={{ fontSize: "16px", marginBottom: "6px" }}>Returned from a pass at {turnedInTime}</div>}
                          {dueTime && (
                            <div style={{ fontSize: "16px" }}>
                              Due back at {dueTime} ={" "}
                              <span style={{ color: mins >= 0 ? "#00FF00" : "#e43522", fontWeight: "bold" }}>
                                {mins >= 0 ? "+" : ""}{mins} min
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Cancel button — outside scroll, returns to main Pass Performance view */}
              <div
                className="field2299"
                onClick={() => { setShowBehaviorDetail(false); setShowPassDetail(false); setLockedModalHeight(null); }}
                style={{ width: "100%", boxSizing: "border-box", marginTop: "15px", flexShrink: 0 }}
              >
                <div className="innertext" style={{ fontSize: "28px" }}>Cancel</div>
              </div>
            </>
          ) : (
            <>
              {/* Behavior section */}
              <div
                style={{
                  backgroundColor: behaviorHover && hasBehavior ? (behaviorPercent >= 100 ? "#00FF00" : "#e43522") : "#013469",
                  border: "3px solid #e43522",
                  borderRadius: "8px",
                  padding: "10px",
                  marginBottom: "10px",
                  cursor: hasBehavior ? "pointer" : "default",
                  position: "relative",
                  transition: "background-color 0.2s",
                }}
                onClick={hasBehavior ? () => { if (modalRef.current) setLockedModalHeight(modalRef.current.offsetHeight); setShowBehaviorDetail(true); } : undefined}
                onMouseEnter={hasBehavior ? () => setBehaviorHover(true) : undefined}
                onMouseLeave={hasBehavior ? () => setBehaviorHover(false) : undefined}
              >
                <div style={{ fontSize: "18px", fontFamily: "sans-serif", borderBottom: "1px solid rgba(228,53,34,0.3)", paddingBottom: "4px", marginBottom: "4px", color: behaviorHover && hasBehavior ? "#000" : "rgba(255,255,255,0.8)", transition: "color 0.2s" }}>Set Standards Of Behavior</div>
                <div style={{ fontSize: "48px", fontWeight: "bold", color: behaviorHover && hasBehavior ? "#013469" : (behaviorPercent >= 100 ? "#00FF00" : "#e43522"), transition: "color 0.2s" }}>
                  {behaviorPercent}%
                </div>
              </div>

              {/* Punctuality section */}
              <div
                style={{
                  backgroundColor: passHover && hasPasses ? (punctualityScore >= 0 ? "#00FF00" : "#e43522") : "#013469",
                  border: "3px solid #e43522",
                  borderRadius: "8px",
                  padding: "10px",
                  marginBottom: "10px",
                  cursor: hasPasses ? "pointer" : "default",
                  position: "relative",
                  transition: "background-color 0.2s",
                }}
                onClick={hasPasses ? () => { if (modalRef.current) setLockedModalHeight(modalRef.current.offsetHeight); setShowPassDetail(true); } : undefined}
                onMouseEnter={hasPasses ? () => setPassHover(true) : undefined}
                onMouseLeave={hasPasses ? () => setPassHover(false) : undefined}
              >
                <div style={{ fontSize: "18px", fontFamily: "sans-serif", borderBottom: "1px solid rgba(228,53,34,0.3)", paddingBottom: "4px", marginBottom: "4px", color: passHover && hasPasses ? "#000" : "rgba(255,255,255,0.8)", transition: "color 0.2s" }}>Punctuality Rating</div>
                <div style={{ fontSize: "48px", fontWeight: "bold", color: passHover && hasPasses ? "#013469" : (punctualityScore >= 0 ? "#00FF00" : "#e43522"), transition: "color 0.2s" }}>
                  {punctualityScore >= 0 ? "+" : ""}{punctualityScore}
                </div>
              </div>

              {/* Feedback section */}
              <div style={{
                backgroundColor: "#013469",
                border: "3px solid #e43522",
                borderRadius: "8px",
                padding: "10px",
                marginBottom: "15px",
                textAlign: "center",
              }}>
                {feedbackHeader ? (
                  <div style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    marginBottom: "4px",
                    color: feedbackHeader === "You cannot get passes now!" || feedbackHeader === "Try to Improve!" ? "#e43522" : "#00FF00",
                  }}>{feedbackHeader}</div>
                ) : null}
                <div style={{ fontSize: "17px", lineHeight: "1.4", whiteSpace: "pre-line", fontFamily: "sans-serif" }}>{feedbackBody}</div>
              </div>

              <div className="field2299" onClick={() => { setShowpassperformance(false); setShowBehaviorDetail(false); setShowPassDetail(false); }} style={{ width: "100%", boxSizing: "border-box" }}>
                <div className="innertext" style={{ fontSize: "28px" }}>Cancel</div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="App22">
      <NavBar
        donotshow={donotshow}
        role={role || role2}  // Pass role from either URL params or state
        temparray={allclassdata}
        selectedclass={selectedclass}
        setSelectedclass={setSelectedclass}
        activeid={activeid}
        id2={id}
        school={school}
        town={town}
        state={state}
        firstname={firstname}
        lastname={lastname}
        currentpage={"Mainmenu"}
        personaldata={personaldata}
        setShowgrades={setShowgrades}
        showgrades={showgrades}
        setShowbirthday={setShowbirthday}
      />

      {typeof showbirthday !== "undefined" && showbirthday === true ? <div
        className="App"
      >
        <Particlestest firstName={nextBirthdayFirstName} lastName={nextBirthdayLastName} />
      </div> : typeof selectedclass == "undefined" || selectedclass == "" ? <div
        className="App"
        onClick={() => setBringinmenu2(!bringinmenu2)}
      >
        <header className="App-header2">
          <img
            src={logo2}
            className={newwidth < 800 ? "App-logo2" : "App-logo2big"}
            alt="logo"
            onClick={() => setBringinmenu2(!bringinmenu2)}
          />

          {school && newwidth < 800 ? (
            <div className="App-logo9">
              <div className="App-logo5">
                <p style={{ fontFamily: "fantasy", fontSize: "25px" }}>- {school} -</p>
              </div>
            </div>
          ) : school ? (
            <div className="App-logo9big">
              <div className="App-logo5big">
                <p style={{ fontFamily: "fantasy", fontSize: "25px" }}>- {school} -</p>
              </div>
            </div>
          ) : null}

        </header>
        <div className="App-footer">
         
          <br />      <br /> <br /> 
          <br />      <br />   <br />
          <Link
            to="/Privacypolicy"
            style={{
              color: "white",
              backgroundColor: "black",
              marginLeft: "auto",
              marginRight: "auto",
              borderRadius: "5px",
            }}
          >
            Privacy Policy
          </Link>
        </div>
      </div> : <div className="App">
        <header className="App-header">
          {typeof currentclass != "undefined" &&
            typeof activeid != "undefined" && passexists == "" && summary != true ? (
            <>
              {showgrades != true ? <div className="centerme29512" style={{ fontFamily: "fantasy"  }}>"{activename}"
              </div> : null}

              {showgrades == true && isClassDataReady && typeof selectedclass != "undefined" ? <>   <div className="App" style={{ maxWidth: newwidth }}>
                <header className="App-header">
                  <Classes
                    gccompare={gccompare2}
                    gcdatasent={gcdatasent2}
                    gctimesent={gctimesent2}
                    gc1title={gc1title2}
                    gc1compare={gc1compare2}
                    gc1datasent={gc1datasent2}
                    gc1timesent={gc1timesent2}
                    setSelectedclass={setSelectedclass2}
                    sid={sid2}
                    only2studentid={id}
                    studentid={id}
                    setSid={setSid2}
                    selectedclass={selectedclass2}
                    selectedclass1={selectedclass12}
                    setSelectedclass1={setSelectedclass12}
                    setShowpersonal={setShowpersonal2}
                    showpersonal={showpersonal2}
                    gradereceived={gradereceived2}
                    nameinobject={nameinobject2}
                    googleclassroomid={googleclassroomid2}
                    averageofgradeswithzeros={averageofgradeswithzeros2}
                    averageofgrades={averageofgrades2}
                    lowscore={lowscore2}
                    highscore={highscore2}
                  />
                </header>
              </div></> : makeapass != true && showgrades == false ? <><div className="field2299" onClick={() => setMakeapass(true)}><div className="innertext">
                Make A Pass
              </div></div>

              {makeapass != true && showgrades == false ? <div className="field2299" onClick={() => setShowpassperformance(true)}><div className="innertext">
               Passes/Behaviors
              </div></div> : null}

                {typeof highscore2 !== "undefined" && highscore2 > 0 && typeof averageofgrades2 !== "undefined" && averageofgrades2 > 0 ? <div className="field2299" onClick={() => setShowgrades(true)}><div className="innertext">
                  Show Grades In Context
                </div></div> : null}

                {makeapass != true && showgrades != true && nextbirthday !== "01/01/2027" && nextBirthdayFirstName !== "" ? <div className="field2299" onClick={() => setShowbirthday(true)}><div className="innertext">
                  Next Birthday {nextbirthday.split("/").slice(0, 2).join("/")}
                </div></div> : null}

              </> : <><div className={custom == true || destination != "" ? "field2299dim" : "field2299"}><div className="innertext">
                Select A Destination
              </div> </div><br></br><br></br><div className={custom == true || (destination != "" && destination != "Bathroom") ? "field2299dim" : "field2299"} onClick={() => destination == "Bathroom" ? setDestination("") : setDestination("Bathroom")}><div className="innertext">
                Bathroom
              </div></div><div className={custom == true || (destination != "" && destination != "Get Drink of Water") ? "field2299dim" : "field2299"} onClick={() => destination == "Get Drink of Water" ? setDestination("") : setDestination("Get Drink of Water")}><div className="innertext">
                Get Drink Of Water
              </div></div><div className={custom == true || (destination != "" && destination != "Nurse") ? "field2299dim" : "field2299"} onClick={() => destination == "Nurse" ? setDestination("") : setDestination("Nurse")}><div className="innertext">
                Nurse</div></div>

                {custom != true || (destination == "Bathroom" || destination == "Get Drink of Water" || destination == "Nurse") ? <div className={destination == "Bathroom" || destination == "Get Drink of Water" || destination == "Nurse" ? "field2299dim" : "field2299"} onClick={() => setCustom(true)}><div className="innertext">
                  Custom
                </div></div> :
                  <div className="field2299">
                    <input
                      className="innertext"
                      style={{
                        width: "100%",
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#000",
                        textAlign: "center",
                        fontSize: "inherit",
                        fontWeight: "inherit",
                        padding: "11px"
                      }}
                      placeholder="Enter Location"
                      value={destination}
                      onChange={(e) => setDestination(e.target.value)}
                      type="text"
                    />
                  </div>}
                {destination.length > 0 ? <div className="field2299" onClick={() => handleBarCodeScanned()}><div className="innertext">
                  Begin Pass</div></div> : <div className="field2299dim" onClick={() => alert("Select a Destination")}><div className="innertext">
                    Begin Pass</div></div>}
              </>}
            </>
          ) : typeof currentclass != "undefined" &&
            typeof activeid != "undefined" && passexists != "" && summary != true ? (
            <>
              <div className="centerme29512" style={{ fontFamily: "fantasy" }}>Pass is Now<br></br>"Active"<br></br>

              </div>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Name</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span
                        style={{
                          minWidth: 80,
                          display: "inline-block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "clip", // or "ellipsis" for ...
                          maxWidth: "100%"
                        }}
                      >
                        {firstname} {lastname}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Today's Date</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{currentdate}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Left Class</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{realtimeleave}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Destination</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{destination}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Allotted Time</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{allottedtime} minutes</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Pass Duration</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{
                        color: secondssince > allottedtime * 60 ? "#FF0000" : "#FFFFFF",
                        minWidth: 80,
                        display: "inline-block"
                      }}>{stringwhichshowsminutesandseconds}</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Should Return</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{realtimereturn}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <br></br><br></br>

              {(!isMobile || localclosewebpass === true) && (
                <div className="field2299" onClick={() => handleBarCodeScanned23()}>
                  <div className="innertext">Return Pass</div>
                </div>
              )}

            </>
          ) : (
            <>
              <div className="centerme29512" style={{ fontFamily: "fantasy" }}>Pass<br></br>Summary<br></br>

              </div>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Student's Name</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{firstname} {lastname}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Today's Date</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{currentdate}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Time Left Class</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{realtimeleave}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Destination</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{destination}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Allotted Time</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{allottedtime} minutes</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Pass Duration</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={timeofreturn < expectedtimeofreturn ? { color: "#00FF00", minWidth: 80, display: "inline-block" } : { color: "#FF0000", minWidth: 80, display: "inline-block" }}>{stringwhichshowsminutesandseconds}</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ textAlign: "right", padding: "4px 28px", width: "50%" }}>Expected Return</td>
                    <td style={{ textAlign: "left", padding: "4px 28px", width: "50%" }}>
                      <span style={{ minWidth: 80, display: "inline-block" }}>{realtimereturn}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <br></br><br></br>


              <div className="field2299" onClick={() => setSelectedclass("")}><div className="innertext">
                Exit</div></div>

            </>
          )}
          <br></br><br></br><br></br><br></br><br></br><br></br>

        </header>
      </div>}
      {renderPassPerformanceModal()}
    </div>
  );
}

export default App;